import React from 'react';
import { TimelineResizingStats } from './ResizeStats.styled';

interface Props {
    resizeStatsRef: React.Ref<HTMLDivElement>;
}

export const ResizeStats = ({ resizeStatsRef }: Props) => {
    return (
        <TimelineResizingStats ref={resizeStatsRef}>
            <span className="timeline__resizing-start-frame-diff" />
            <span className="timeline__resizing-duration-name">Duration:</span>
            <span className="timeline__resizing-duration" />
        </TimelineResizingStats>
    );
};
